<div id="home-content" class="content">
  <div id="home-page-header">
    <img id="pig-logo-home" src="/assets/images/pig-logo-home.png" />
    <img id="text-logo-home" src="/assets/images/piggly-wiggly-text-logo.png" />
    <span>Retail Price Management System</span>
  </div>
  <div id="home-tiles" class="cf">

        <div class="tile-wrapper multiple-windows">
      <mat-card appearance="outlined" class="price-card">
        <i class="far fa-usd-circle"></i>
        <div class="card-content-wrapper">
          <h2>Preview Price Management Windows</h2>
          <mat-card-content>

            <!-- Grocery Preview -->
            <div class="row">
              <div class="row-content">
                <div class="status-type">
                  <div *ngIf="previewPricingWindowOpen">
                    <div class="window-open">OPEN</div>
                  </div>
                  <div *ngIf="!previewPricingWindowOpen">
                    <div class="window-closed">CLOSED</div>
                  </div>
                  <div class="type-name">GROCERY</div>
                </div>
                <div class="countdown">
                  <span *ngIf="previewPricingWindowOpen">Closes in: </span>
                  <span *ngIf="!previewPricingWindowOpen">Opens in: </span>
                  {{previewWindowCountdownTimer}}
                </div>
              </div>

              <div>
                <div class="go" (click)="goToPriceManagement('[Grocery Preview]','Preview','GroceryPreviewItems')">GO</div>
              </div>
            </div>
            
            <!-- Meat Preview -->
            <div class="row">
              <div class="row-content">
                <div class="status-type">
                  <div *ngIf="meatPreviewPricingWindowOpen">
                    <div class="window-open">OPEN</div>
                  </div>
                  <div *ngIf="!meatPreviewPricingWindowOpen">
                    <div class="window-closed">CLOSED</div>
                  </div>
                  <div class="type-name">MEAT</div>
                </div>
                <div class="countdown">
                  <span *ngIf="meatPreviewPricingWindowOpen">Closes in: </span>
                  <span *ngIf="!meatPreviewPricingWindowOpen">Opens in: </span>
                  {{meatPreviewWindowCountdownTimer}}
                </div>
              </div>

              <div>
                <div class="go" (click)="goToPriceManagement('[Meat Preview]','Preview','MeatPreviewItems')">GO</div>
              </div>
            </div>

            <!-- Produce Preview -->
            <div class="row">
              <div class="row-content">
                <div class="status-type">
                  <div *ngIf="producePreviewPricingWindowOpen">
                    <div class="window-open">OPEN</div>
                  </div>
                  <div *ngIf="!producePreviewPricingWindowOpen">
                    <div class="window-closed">CLOSED</div>
                  </div>
                  <div class="type-name">PRODUCE</div>
                </div>
                <div class="countdown">
                  <span *ngIf="producePreviewPricingWindowOpen">Closes in: </span>
                  <span *ngIf="!producePreviewPricingWindowOpen">Opens in: </span>
                  {{producePreviewWindowCountdownTimer}}
                </div>
              </div>

              <div>
                <div class="go" (click)="goToPriceManagement('[Produce Preview]','Preview','ProducePreviewItems')">GO</div>
              </div>

            </div>
          </mat-card-content>
        </div>
      </mat-card>
    </div>

    <div class="tile-wrapper multiple-windows">
      <mat-card appearance="outlined" class="price-card">
        <i class="far fa-usd-circle"></i>
        <div class="card-content-wrapper">
          <h2>Store Price Management Windows</h2>
          <mat-card-content>

            <!-- Grocery -->
            <div class="row">
              <div class="row-content">
                <div class="status-type">
                  <div *ngIf="storeItemPricingWindowOpen">
                    <div class="window-open">OPEN</div>
                  </div>
                  <div *ngIf="!storeItemPricingWindowOpen">
                    <div class="window-closed">CLOSED</div>
                  </div>
                  <div class="type-name">GROCERY</div>
                </div>
                <div class="countdown">
                  <span *ngIf="storeItemPricingWindowOpen">Closes in: </span>
                  <span *ngIf="!storeItemPricingWindowOpen">Opens in: </span>
                  {{storeItemPricingWindowCountdownTimer}}
                </div>
              </div>

              <div>
                <div class="go" (click)="goToPriceManagement('','AllItems','AllItems')">GO</div>
              </div>
            </div>
     
            <!-- Meat -->
            <div class="row">
              <div class="row-content">
                <div class="status-type">
                  <div *ngIf="meatStoreItemPricingWindowOpen">
                    <div class="window-open">OPEN</div>
                  </div>
                  <div *ngIf="!meatStoreItemPricingWindowOpen">
                    <div class="window-closed">CLOSED</div>
                  </div>
                  <div class="type-name">MEAT</div>
                </div>
                <div class="countdown">
                  <span *ngIf="meatStoreItemPricingWindowOpen">Closes in: </span>
                  <span *ngIf="!meatStoreItemPricingWindowOpen">Opens in: </span>
                  {{meatStoreItemPricingWindowCountdownTimer}}
                </div>
              </div>

              <div>
                <div class="go" (click)="goToPriceManagement('[Meat]','Meat','StockItems')">GO</div>
              </div>
            </div>

            <!-- Produce -->
            <div class="row">
              <div class="row-content">
                <div class="status-type">
                  <div *ngIf="produceStoreItemPricingWindowOpen">
                    <div class="window-open">OPEN</div>
                  </div>
                  <div *ngIf="!produceStoreItemPricingWindowOpen">
                    <div class="window-closed">CLOSED</div>
                  </div>
                  <div class="type-name">PRODUCE</div>
                </div>
                <div class="countdown">
                  <span *ngIf="produceStoreItemPricingWindowOpen">Closes in: </span>
                  <span *ngIf="!produceStoreItemPricingWindowOpen">Opens in: </span>
                  {{produceStoreItemPricingWindowCountdownTimer}}
                </div>
              </div>

              <div>
                <div class="go" (click)="goToPriceManagement('[Produce]','Produce','StockItems')">GO</div>
              </div>
            </div>
          </mat-card-content>
        </div>
      </mat-card>
    </div>

    <div class="tile-wrapper">
      <mat-card appearance="outlined" (click)="goToPriceManagement('[First Time Buys or NOWs]','AllItems','AllItems')" class="price-card">
        <i class="far fa-usd-circle"></i>
        <div class="card-content-wrapper">
          <h2>First Time Buys &amp; Now Cost Changes</h2>
          <mat-card-content>
            <p>There are <span [innerHtml]="firstTimeBuysCount"></span> First Time Buys and <span [innerHtml]="nowCostChangesCount"></span> Now Cost Changes as of {{now | date:'short'}}.</p>
          </mat-card-content>
        </div>
        <mat-card-footer class="right-justified">
          <button mat-raised-button color="primary">Go</button>
        </mat-card-footer>
      </mat-card>
    </div>

    <div class="tile-wrapper" *ngIf="permissions.roleAllowsUserToExportCashRegisterFile">
      <mat-card appearance="outlined" class="report-card" (click)="onExportClick()">
        <i class="far fa-file-spreadsheet"></i>
        <div class="card-content-wrapper">
          <h2>Export Cash Register File</h2>
          <mat-card-content>
              <p>Export the Grocery cash register file for the latest week.</p>
          </mat-card-content>
        </div>
        <mat-card-footer class="right-justified">
          <button mat-raised-button color="primary">Go</button>
        </mat-card-footer>
      </mat-card>
    </div>

  </div>
  <div *ngFor="let announcement of announcements">
		<div class="announcement">{{announcement.message}}</div>
	</div>
</div>